"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputValidationError = exports.ErrorContainer = void 0;
const styled_1 = __importDefault(require("../../../styles/styled"));
const layout_1 = require("../../layout");
exports.ErrorContainer = (0, styled_1.default)(layout_1.Box)(({ theme }) => ({
    border: '1px solid transparent',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: '34px',
}));
exports.InputValidationError = (0, styled_1.default)(layout_1.Box)(({ theme }) => ({
    borderRadius: '2px',
    marginLeft: '4px',
    backgroundColor: 'transparent',
    fontFamily: theme.text.bodyFontFamily,
    fontSize: theme.text.size.small,
    width: '100%',
    height: '100%',
}));
//# sourceMappingURL=form_validation.js.map